// extracted by mini-css-extract-plugin
export var layoutContainer = "_6a-0";
export var layoutContainerNoRounding = "_6a-6";
export var layoutContainerOpen = "_6a-5";
export var layoutContainerResizing = "_6a-1";
export var mainContent = "_6a-2";
export var resizeDivider = "_6a-3";
export var slidePanel = "_6a-4";